module.exports = __webpack_public_path__ + "static/media/ServicesQualityAssuranceIcon.00e79b16.svg";